import React from 'react';

import { ImageOnly, TextBanner, TextOnImage, TextUnderneath } from './variants';

import { FullWidthContentType } from '../../models/strapi/full_width_content';

interface Props {
    data: FullWidthContentType;
    isMobile?: boolean;
    overlay?: boolean; //Dark mobile background for textOnImage variant
}

const StrapiFullWidthContent = ({ data, isMobile, overlay }: Props) => {
    if (
        data.variant === 'textOnImage' &&
        data.textOnImageMobileVariant === 'textOverlay' &&
        isMobile === undefined
    ) {
        // eslint-disable-next-line no-console
        console.error(
            'Web-Gatsby component library: isMobile prop required when using "textOverlay" mobile variant'
        );
    }

    switch (data.variant) {
        case 'textOnImage': {
            return <TextOnImage data={data} overlay={overlay} />;
        }
        case 'textOnly':
        case 'textBanner': {
            return <TextBanner data={data} variant={data.variant} />;
        }
        case 'imageOnly': {
            return <ImageOnly data={data} />;
        }
        case 'imageAbove': {
            return <TextUnderneath data={data} />;
        }
        default: {
            // eslint-disable-next-line no-console
            console.error('Web-Gatsby component library: Missing fullWidthContent variant');
            return <div>Please select a variant.</div>;
        }
    }
};

export default StrapiFullWidthContent;
